import { colors } from '@lmc/common/constants'
import type { Log } from '@lmc/ts-common'
import dayjs from 'dayjs'
import type React from 'react'
import styled from 'styled-components'
import { LogSummary, ResidentPictureName } from '../../../../components/generic'
import { history } from '../../../../store'
import { commonPatterns } from '../../../../utils/enhancedTestIds'

interface LogsTableItemProps {
  log: Log
  residentStyle?: React.CSSProperties
  linkEnabled?: boolean
  testId?: string
  index?: number
}

export const LogsTableItem: React.FC<LogsTableItemProps> = ({
  log,
  residentStyle,
  linkEnabled,
  testId,
  index
}) => {
  const isDeleted = log.deleted
  const redirect = (url: string) => history.push(`/${url}`)

  const rowId = index !== undefined ? index : 0
  const itemTestId = testId
    ? commonPatterns.row(`${testId}-summary`, rowId)
    : undefined
  const timeTestId = testId ? `${testId}-row-time-${rowId}` : undefined
  const residentTestId = testId ? `${testId}-row-resident-${rowId}` : undefined
  const logTestId = testId ? `${testId}-row-log-${rowId}` : undefined

  return (
    <Wrapper data-testid={itemTestId}>
      <TimeLoggedContainer $isDeleted={isDeleted} data-testid={timeTestId}>
        {dayjs(log.timeLogged).format('DD-MM-YYYY HH:mm')}
      </TimeLoggedContainer>
      <ResidentPictureName
        data={log.resident}
        isLogRemoved={log.deleted}
        onSelect={redirect}
        style={residentStyle}
        testId={residentTestId}
      />
      <LogSummary
        data={log}
        isLogRemoved={log.deleted}
        linkEnabled={linkEnabled}
        onSelect={redirect}
        testId={logTestId}
      />
    </Wrapper>
  )
}

export default LogsTableItem

const Wrapper = styled.div`
  border-bottom: 1px solid;
  border-color: ${colors.grey};
  display: flex;
  padding: 16px 0px;
`

const TimeLoggedContainer = styled.div<{ $isDeleted?: boolean }>`
  margin-right: 12px;
  padding-top: 12px;
  width: 20%;
  color: ${({ $isDeleted }) => ($isDeleted ? colors.darkgrey : 'inherit')};
`
